export const notificationStatuses = {
  templateApproved: "TemplateApproved",
  templateRejected: "TemplateRejected",
  assessmentApproved: "AssessmentApproved",
  assessmentRejected: "AssessmentRejected",
  ok: "OK",
}
